import { Divider, Flex, Title } from '@tremor/react'
import { useEffect, useState } from 'react'

interface IModal {
    children: any
    show: boolean
    title: string
    onCloseClicked: () => void
    className?: string
    position?: 'sticky-right' | 'center'
}

export default function Modal({
    children,
    title,
    show,
    onCloseClicked,
    className,
    position = 'sticky-right',
}: IModal) {
    const [isVisible, setIsVisible] = useState(show)

    useEffect(() => {
        if (show) {
            setIsVisible(true)
            return () => 0
        }
        const timeout = setTimeout(() => setIsVisible(false), 150)
        return () => clearTimeout(timeout)
    }, [show])

    return (
        <Flex
            flexDirection="col"
            justifyContent={position === 'center' ? 'center' : 'start'}
            alignItems={position === 'center' ? 'center' : 'end'}
            className={`fixed top-0 left-0 w-screen h-screen bg-gray-900/50 z-50 transition-opacity duration-150 ease-linear ${
                show ? 'opacity-100 visible' : 'opacity-0'
            } ${isVisible ? 'visible' : 'invisible'}`}
            onClick={onCloseClicked}
        >
            <Flex
                flexDirection="row"
                alignItems="start"
                justifyContent="start"
                className={`w-fit  bg-white pb-5 overflow-y-auto transition-all ${
                    show ? 'relative left-0' : 'relative left-96'
                } ${
                    position === 'center'
                        ? 'h-fit rounded-md'
                        : 'h-screen border-l border-gray-300'
                } ${className}`}
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <Flex
                    flexDirection="col"
                    justifyContent="start"
                    alignItems="start"
                    className=""
                >
                    <Title className="p-4">{title}</Title>
                    <Divider className="m-0 p-0" />
                    <Flex
                        flexDirection="col"
                        justifyContent="start"
                        alignItems="start"
                        className="px-8"
                    >
                        {children}
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    )
}
